import { gql } from '@apollo/client';
import {
  CommonLocalizableString,
  CommonLocalizableImage,
  CommonBoothTier,
  CommonBoothMetadata,
} from 'network/common/cmsFragment';
import { fetchMetaBoothsRequest } from 'network/queue';
import { APP_DOMAIN } from 'appenv';

interface FetchMetaBoothsProps {
  locales: string[];
  categoryIds: string[];
  count?: number;
  cursor?: string;
}

const fetchMetaBoothsQuery = gql`
  query fetchMetaBoothsQuery(
    $domain: String!
    $locales: [Locale!]!
    $categoryIds: [ID!]!
    $count: Int
    $cursor: String
  ) {
    data: eventByDomain(domain: $domain) {
      id
      boothsByFilter(
        published: true,
        categoryIds: $categoryIds,
        first: $count,
        after: $cursor
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          ...CommonBoothMetadata
        }
      }
    }
  }

  ${CommonLocalizableString}
  ${CommonLocalizableImage}
  ${CommonBoothTier}
  ${CommonBoothMetadata}
`;

const fetchMetaBooths = async (config: FetchMetaBoothsProps) => (
  fetchMetaBoothsRequest({
    query: fetchMetaBoothsQuery,
    variables: {
      ...config,
      count: config.count || 20,
      domain: APP_DOMAIN,
    },
    fetchPolicy: 'cache-first',
  }).then((response) => response.data)
);

export default fetchMetaBooths;
